import { containsEmptyValues } from "../../../utils/containsEmptyValues";

type SubmissionShape = {
  id: string; // meterId
  readingDttm: string;
  sequenceType: string;
  readings: { id: string; cumulative: string }[];
};
export const transformFormValuesToAPIShape = (
  formValues: Record<string, any>,
): SubmissionShape[] => {
  const readingDttm = formValues.readingDttm;
  const tabData = Object.entries(formValues).filter(
    ([key]) => key !== "readingDttm",
  );

  // Strip any empty tabs from the payload
  // Add the reading datetime to all individual meter objects
  const payload = tabData.reduce((data: any[], [meterId, values]) => {
    const isEmpty = containsEmptyValues(values);

    return !isEmpty
      ? [
          ...data,
          {
            readingDttm,
            ...values,
          },
        ]
      : data;
  }, []);

  return payload;
};
